import { select, takeLatest, call, put } from 'redux-saga/effects';
import { getSuccess, getFailure, postSuccess, postFailure, getSuccessUserList, getFailureUserList, deleteUserSuccess, deleteUserFailure, putUserFailure, putUserSuccess, getStaffListSuccess, getStaffListFailure, sendResetEmailSuccess, sendResetEmailFailure, setUserStatusSuccess, setUserStatusFailure } from './slice';
import { apiGet, apiPost, apiPut, apiPatch, apiDelete, apiUpload } from '../../../api/client';
function* getRequest(action) {
    try {
const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(apiGet, `api/staff?name=${action.payload}`);
        yield put(getSuccess(response));
    } catch (error) {
        yield put(getFailure(error?.response?.message || error));
    }
}

function* getRequestUserList(action) {
    try {
const { page, limit, searchQuery } = action.payload || { page: 1, limit: null, searchQuery: "" };
        const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(apiGet, `api/userlist?page=${page}&limit=${limit}&searchQuery=${searchQuery}`);
        yield put(getSuccessUserList(response));
    } catch (error) {
        yield put(getFailureUserList(error?.response?.message || error));
    }
}



function* postRequest(action) {
    try {
const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(apiPost, 'api/user', action.payload);
        yield put(postSuccess(response));
    } catch (error) {
        yield put(postFailure(error?.response?.message || error));
    }
}


function* deleteUserRequest(action) {
    try {
const currentBranch = yield select(state => state.branch.currentBranch);

        const response = yield call(apiDelete, `api/user/${action.payload}`);
        yield put(deleteUserSuccess(response));
    } catch (error) {
        yield put(deleteUserFailure(error?.response?.message || error));
    }
}

function* putUserRequest(action) {
    try {
const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(apiPut, 'api/user', action.payload);
        yield put(putUserSuccess(response));
    } catch (error) {
        yield put(putUserFailure(error?.response?.message || error));
    }
}

function* getStaffList(action) {
    try {
const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(apiGet, 'api/saff-list');
        yield put(getStaffListSuccess(response));
    } catch (error) {
        yield put(getStaffListFailure(error?.response?.message || error));
    }
}

function* sendResetEmail(action) {
    try {
const response = yield call(apiPost, `api/user/send-reset-email/${action.payload}`, {});
        yield put(sendResetEmailSuccess(response));
    } catch (error) {
        yield put(sendResetEmailFailure(error?.response?.message || error));
    }
}

function* setUserStatus(action) {
    try {
        const { id, isActive, reason } = action.payload;
        const response = yield call(apiPatch, `api/user/${id}/status`, { isActive, reason });
        yield put(setUserStatusSuccess(response));
    } catch (error) {
        // The api client throws an Error carrying the friendly message, so
        // normalize to the { success, message } shape the list UI reads.
        yield put(setUserStatusFailure({ success: false, message: error?.message || 'Could not update account status.' }));
    }
}

function* saga() {
    yield takeLatest('staff/getRequest', getRequest);
    yield takeLatest('staff/deleteUserRequest', deleteUserRequest);
    yield takeLatest('staff/getRequestUserList', getRequestUserList);
    yield takeLatest('staff/postRequest', postRequest);
    yield takeLatest('staff/putUserRequest', putUserRequest);
    yield takeLatest('staff/getStaffList', getStaffList);
    yield takeLatest('staff/sendResetEmailRequest', sendResetEmail);
    yield takeLatest('staff/setUserStatusRequest', setUserStatus);
}

export default saga;